import { useState } from "react";
import { useParams } from "react-router-dom";
import { infoUpdateType } from "types/notifications";
import { useSubscribeToSocketEvent } from "./useSubscribeToSocketEvent";

type Params = {
  callback: (data: infoUpdateType) => void
}

export const useDropboxsignEvent = ({ callback }: Params) => {
  const { id: orderId } = useParams<{ id: string }>();
  const [time, setTime] = useState<string|null>(null);

  useSubscribeToSocketEvent({
    eventKey: 'dropboxSignHook',
    callback: (data: infoUpdateType) => {
      const actualDate = new Date();
      if (data.update?._id === orderId) {
        setTime(actualDate.getTime().toString());
        callback(data);
      }
    }
  });
  return {
    time
  };
};